var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGestureOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50001 17.5119C6.50001 21.0967 9.41014 24.0027 13.0001 24.0028L14 24.0029L14 26L13 26C8.30552 25.9998 4.50001 22.1996 4.50001 17.5119H6.50001Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6385 4.03102C15.8825 3.86327 15.1344 4.34259 14.9721 5.09871L13.9778 9.73077C13.862 10.27 13.3304 10.6135 12.7904 10.4979C12.2504 10.3823 11.9065 9.85144 12.0222 9.3122L13.0165 4.68014C13.4116 2.83981 15.2323 1.67317 17.0723 2.08147C18.7921 2.46308 19.9337 4.0949 19.7009 5.83863L18.9912 11.1533C18.9182 11.6999 18.4153 12.084 17.8678 12.0111C17.3204 11.9382 16.9358 11.436 17.0088 10.8893L17.7184 5.57468C17.8141 4.85826 17.345 4.18781 16.6385 4.03102Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22343 6.05496C8.15207 5.23555 8.79894 4.53101 9.62263 4.53101C10.2671 4.53101 10.8289 4.96899 10.9852 5.59332L12.0298 9.76598C12.1638 10.301 12.7067 10.6263 13.2425 10.4925C13.7783 10.3588 14.1041 9.81663 13.9701 9.28161L12.9255 5.10894C12.5466 3.59557 11.1848 2.5339 9.62263 2.5339C7.626 2.5339 6.05798 4.24172 6.23095 6.22797L6.97064 14.7221L8.87471 13.5338L8.22343 6.05496Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4725 14.7519C12.3215 14.0735 11.6973 13.6067 11.0029 13.653L9.76704 13.7353C7.92856 13.8578 6.5 15.3826 6.5 17.2225L6.50001 17.5119C6.50001 18.0634 6.05228 18.5108 5.5 18.5108C4.94772 18.5108 4.50001 18.0634 4.50001 17.5119L4.5 17.2225C4.5 14.3312 6.74487 11.935 9.63391 11.7426L10.8698 11.6603C12.5495 11.5484 14.0596 12.6776 14.4248 14.3187C14.8488 16.2239 13.5851 18.0944 11.6572 18.4152L11.1644 18.4972C10.6196 18.5879 10.1044 18.2204 10.0136 17.6764C9.92281 17.1324 10.2908 16.6179 10.8356 16.5273L11.3284 16.4453C12.1253 16.3126 12.6477 15.5395 12.4725 14.7519Z",
    fill: "#023F80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 16.0141C22 13.8081 20.2091 12.0199 18 12.0199V10.0228C21.3137 10.0228 24 12.7052 24 16.0141V16.1718C24 21.5996 19.5935 25.9997 14.1579 25.9997H13.5V24.0026H14.1579C18.489 24.0026 22 20.4966 22 16.1718V16.0141Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestureOutline);
export default __webpack_public_path__ + "static/media/gesture_outline.59ff8c3b7ef34277814225ae8f5f3867.svg";
export { ForwardRef as ReactComponent };